import OlMap from 'ol/Map';
import { IHeaders } from '@/@types/lib/api/api';
import { IGSService, GFIResponseType, GFILayerFeatureType, GFIFeatureType } from '@/@types/services/gsService';
import { authHeader } from '@/lib/api/authHeader';
import mapService from './mapService';

const gsService: IGSService = {
  getFeatureInfo,
  getImageUrl,
};

const INFO_FORMAT_JSON = 'application/json';
const INFO_FORMAT_HTML = 'text/html';
const INFO_FORMAT_TEXT = 'text/plain';


function getFeatureInfo(map: OlMap, point: number[], gsLayers: Array<string>): Promise<GFIResponseType | null> {
  let headers: IHeaders = authHeader();
  headers['Content-Type'] = 'text/plain';
  headers['Accept'] = 'text/html';

  const mapSize = map.getSize();
  const extent = map.getView().calculateExtent(mapSize);

  const requestOptions = {
    method: 'GET',
    headers: headers,
  };

  //TODO: need to define in which layer are we seraching for.
  //const query_layers = ["DVK:data"];
  const query_layers = gsLayers;

  let layers = query_layers.join(',');

  const gsUrl = process.env.REACT_APP_GEOSERVERPATH;
  const url =
    gsUrl +
    '?SERVICE=WMS' +
    '&VERSION=1.1.1' +
    '&REQUEST=GetFeatureInfo' +
    '&LAYERS=' +
    layers +
    '&STYLES=' +
    '&SRS=EPSG:3857' +
    '&BBOX=' +
    extent +
    '&WIDTH=' +
    (Array.isArray(mapSize) ? mapSize[0] : '') +
    '&HEIGHT=' +
    (Array.isArray(mapSize) ? mapSize[1] : '') +
    '&QUERY_LAYERS=' +
    layers +
    '&FORMAT=image/png' +
    '&INFO_FORMAT=' +
    INFO_FORMAT_JSON +
    '&FEATURE_COUNT=100' +
    '&X=' +
    point[0].toFixed(0) +
    '&Y=' +
    point[1].toFixed(0);
  // + "&BUFFER=10"
  return fetch(url, requestOptions)
    .then((response) => {
      return response.text().then((text) => {
        if (!response.ok) {
          console.log(response);
          return null;
        } else {
          const js = JSON.parse(text);
          const data = parseFeatures(js.features as GFIFeatureType[]);
          return data;
        }
        // const data = text && JSON.parse(text)
        // if (!response.ok) {
        //   const error = (data && data.message) || response.statusText;
        //   return Promise.reject(error);
        // }

        // return data;
      });
    })
    .catch(function (error) {
      return null;
    });
}

function parseFeatures(features: GFIFeatureType[]) {
  const layerFeatures: Array<GFILayerFeatureType> = features.map((feature) => {
    const ind = feature.id.indexOf('.');
    const layerId = feature.id.slice(0, ind);
    const properId = feature.id.slice(ind + 1);
    for (var propName in feature.properties) {
      if (feature.properties[propName] === null) {
        delete feature.properties[propName];
      }
    }
    return {
      layerId: layerId,
      properId: properId,
      properties: feature.properties,
      geometry_name: feature.geometry_name,
      geometry: feature.geometry,
    } as GFILayerFeatureType;
  });
  return sortInLayers(layerFeatures);
}

function sortInLayers(object: Array<GFILayerFeatureType>) {
  var resp: GFIResponseType = {};
  for (var feature of object) {
    const newFeat: GFIFeatureType = {
      id: feature.properId,
      properties: feature.properties,
      geometry: feature.geometry,
      geometry_name: feature.geometry_name,
    };

    if (resp[feature.layerId]) {
      resp[feature.layerId].push(newFeat);
    } else {
      resp[feature.layerId] = [newFeat];
    }
  }
  return resp;
}

function getImageUrl(
  layers: string[],
  izlet_id: number | string,
  bbox: [number, number, number, number],
  width: number = 300,
  height: number = 300
) {
  const authToken = localStorage.getItem('auth_token');
  const gsUrl = process.env.REACT_APP_GEOSERVERPATH;

  let [minX, minY, maxX, maxY] = bbox;

  const bboxWidth = maxX - minX;
  const bboxHeight = maxY - minY;

  const bboxAspectRatio = bboxWidth / bboxHeight;
  const imageAspectRatio = width / height;

  if (bboxAspectRatio > imageAspectRatio) {
    // BBOX is too wide -> extend height
    const newHeight = bboxWidth / imageAspectRatio;
    const heightDiff = newHeight - bboxHeight;
    minY -= heightDiff / 2;
    maxY += heightDiff / 2;
  } else if (bboxAspectRatio < imageAspectRatio) {
    // BBOX is too tall -> extend width
    const newWidth = bboxHeight * imageAspectRatio;
    const widthDiff = newWidth - bboxWidth;
    minX -= widthDiff / 2;
    maxX += widthDiff / 2;
  }

  const adjustedBbox = [minX, minY, maxX, maxY];

  const url =
    `${gsUrl}?service=WMS&version=1.1.0&request=GetMap` +
    `&layers=${layers.join(',')}&styles=&bbox=${adjustedBbox.join(',')}&width=${width}&height=${height}&srs=EPSG:3765` +
    `&format=image/png&viewParams=IZLETID:${izlet_id}&authkey=${authToken}`;

  return url;
}

export default gsService;
